import { render, staticRenderFns } from "./stores-map.vue?vue&type=template&id=6f04fd0f&"
import script from "./stores-map.vue?vue&type=script&lang=js&"
export * from "./stores-map.vue?vue&type=script&lang=js&"
import style0 from "./stores-map.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f04fd0f')) {
      api.createRecord('6f04fd0f', component.options)
    } else {
      api.reload('6f04fd0f', component.options)
    }
    module.hot.accept("./stores-map.vue?vue&type=template&id=6f04fd0f&", function () {
      api.rerender('6f04fd0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/stores/stores-map.vue"
export default component.exports